import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/store/AuthContext";
import { toast } from "sonner";
import { LogIn } from "lucide-react";

export default function AdminLogin() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Welcome back, Sonny.");
      navigate("/admin");
    } catch (err) {
      const detail = err.response?.data?.detail;
      toast.error(typeof detail === "string" ? detail : "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-[80vh] flex items-center justify-center p-6 fade-up" data-testid="admin-login-page">
      <div className="w-full max-w-md card-base p-8">
        <div className="mb-7">
          <h1 className="font-display text-3xl font-bold tracking-tighter">Producer Login</h1>
          <p className="text-sm text-[var(--text-dim)] mt-1">Sign in to manage your beats and sales.</p>
        </div>
        <form onSubmit={onSubmit} className="space-y-4">
          <div>
            <label className="text-xs uppercase tracking-wider text-[var(--text-dim)]">Email</label>
            <input
              type="email"
              autoComplete="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="input-base w-full mt-1 px-3 py-2.5"
              data-testid="admin-login-email"
            />
          </div>
          <div>
            <label className="text-xs uppercase tracking-wider text-[var(--text-dim)]">Password</label>
            <input
              type="password"
              autoComplete="current-password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="input-base w-full mt-1 px-3 py-2.5"
              data-testid="admin-login-password"
            />
          </div>
          <button
            type="submit"
            disabled={loading}
            className="btn-primary w-full py-2.5 flex items-center justify-center gap-2 disabled:opacity-60"
            data-testid="admin-login-submit"
          >
            <LogIn className="w-4 h-4" />
            {loading ? "Signing in…" : "Sign in"}
          </button>
        </form>
      </div>
    </div>
  );
}
